<template>
    <div>
        <a-button type="danger" @click="generatePDF()"> Gerar PDF! </a-button>

        <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="true"
            :image="{type: 'jpeg', quality: 1}"
            filename="hee hee"
            :pdf-quality="2"
            :manual-pagination="true"
            pdf-format="a2"
            pdf-orientation="portrait"
            
            ref="html2Pdf"

            @progress="onProgress($event)"
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
        >

            <section slot="pdf-content">
                <span class="link-code w-full text-center"> ABC12345 </span>
                <span class="table-number w-full text-center"> MESA 01 </span>
                <!-- <img src="@/assets/images/totem/background_red.png" /> -->
            </section>

        </vue-html2pdf>        
    </div>
</template>

<script>
    import VueHtml2pdf from 'vue-html2pdf'

    export default {
        components: {
            VueHtml2pdf
        },

        data () {
            return {

            }
        },

        methods : {
            generatePDF() {
                this.$refs.html2Pdf.generatePdf()
            },

            onProgress (e) {
            },

            hasStartedGeneration () {
                conosle.log('Started generation')
            },

            hasGenerated (e) {
            }
        }
    }
</script>

<style>
    .link-code {
        color: white;
        font-family: 'Jimmy Sans';
        position: fixed;
        top: 680px;
        font-size: 90px;
    }

    .table-number { 
        color: white;
        font-family: 'Jimmy Sans';
        position: fixed;
        top: 1720px;
        font-size: 120px;
    }
</style>